import { useState } from "react";
import { Helmet } from "react-helmet";

import SearchInput from "./components/invoiceInput/search-input";
import Sidebar from "./components/invoiceSidebar/sidebar";
import MainContent from "./components/mainContent/main";
import { Tariff } from "./interfaces/invoices-response";
import { Container, InitialScreen, InitialContent, MainScreen } from "./style";

import { useGetInvoices } from "@/core/libs/api/react-query/hook/use-get-invoices";
import { cpfCnpjFormatter } from "@/utils/FormatCPForCNPJ";

export default function InvoiceViewer() {
  const [searchValue, setSearchValue] = useState("");
  const [isSearched, setIsSearched] = useState(false);
  const [expandedInvoices, setExpandedInvoices] = useState<number[]>([]);
  const [selectedTariff, setSelectedTariff] = useState<Tariff | null>(null);
  const [searchDocument, setSearchDocument] = useState<string | undefined>(
    undefined
  );

  const cleanedDocument = searchValue.replace(/\D/g, "");

  const { accountData, invoicesList, isLoadingInvoices } = useGetInvoices({
    params: searchDocument ? { document: searchDocument } : undefined
  });

  const handleInputChange = (value: string) => {
    const formatted = cpfCnpjFormatter(value);
    setSearchValue(formatted);
  };

  const handleSearch = () => {
    if (searchValue.trim()) {
      setIsSearched(true);
      setExpandedInvoices([]);
      setSelectedTariff(null);
      setSearchDocument(cleanedDocument);
    }
  };

  const toggleInvoiceExpansion = (invoiceId: number) => {
    if (expandedInvoices.includes(invoiceId)) {
      setExpandedInvoices([]);
      setSelectedTariff(null);
    } else {
      setExpandedInvoices([invoiceId]);
    }
  };

  const handleTariffSelect = (tariff: Tariff) => {
    setSelectedTariff(tariff);
  };

  return (
    <Container>
      <>
        <h2 className="ms-fontSize-24">Consulta de Faturas</h2>
        <Helmet>
          <title>Busca de Faturas - Libertas</title>
        </Helmet>
      </>
      {!isSearched ? (
        <InitialScreen>
          <InitialContent>
            <SearchInput
              value={searchValue}
              onChange={handleInputChange}
              onSearch={handleSearch}
              size="large"
            />
          </InitialContent>
        </InitialScreen>
      ) : (
        <MainScreen>
          <Sidebar
            searchValue={searchValue}
            onSearchChange={handleInputChange}
            onSearch={handleSearch}
            account={accountData}
            invoices={invoicesList || []}
            expandedInvoices={expandedInvoices}
            onToggleInvoice={toggleInvoiceExpansion}
            selectedTariff={selectedTariff}
            onTariffSelect={handleTariffSelect}
            isLoading={isLoadingInvoices}
            document={cleanedDocument}
          />
          <MainContent
            selectedTariff={selectedTariff}
            isLoading={isLoadingInvoices}
            invoiceId={expandedInvoices[0]}
            document={cleanedDocument}
          />
        </MainScreen>
      )}
    </Container>
  );
}
